import { z } from 'zod';
import { UserRefSchema } from '../user-ref';

export const DeviceOsSchema = z.enum(['ios', 'android', 'other']);
export type DeviceOs = z.infer<typeof DeviceOsSchema>;

export const DeviceStatusSchema = z.enum(['available', 'assigned', 'lost', 'retired']);
export type DeviceStatus = z.infer<typeof DeviceStatusSchema>;

const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'must be YYYY-MM-DD');

export const DeviceRowSchema = z.object({
  id: z.string().uuid(),
  assignedUserId: z.string().uuid().nullable(),
  assignedUser: UserRefSchema.nullable(),
  name: z.string(),
  model: z.string(),
  os: DeviceOsSchema,
  serial: z.string(),
  imei: z.string(),
  status: DeviceStatusSchema,
  notes: z.string(),
  purchaseDate: z.string().nullable(),
  warrantyExpiresAt: z.string().nullable(),
  lastSeenAt: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type DeviceRow = z.infer<typeof DeviceRowSchema>;

export const InventoryFieldsSchema = z.object({
  purchaseDate: isoDate.optional().nullable(),
  warrantyExpiresAt: isoDate.optional().nullable(),
});

export const AssignmentHistorySchema = z.object({
  id: z.string().uuid(),
  userId: z.string().uuid(),
  userDisplayName: z.string(),
  userEmail: z.string().email(),
  assignedAt: z.string(),
  unassignedAt: z.string().nullable(),
  note: z.string(),
  byUserId: z.string().uuid(),
});
export type AssignmentHistoryItem = z.infer<typeof AssignmentHistorySchema>;
